// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__erg0W","active":"NavbarItem_active__vRVwE","dropdownMenu":"NavbarItem_dropdownMenu__IeObS","dropDownitems":"NavbarItem_dropDownitems__lc8An"};